export const howManyDaysAWeekOptions = [
  { label: '0', value: '0' },
  { label: '1-2', value: '1-2' },
  { label: '3-4', value: '3-4' },
  { label: '5-6', value: '5-6' },
  { label: '7', value: '7' },
]
